import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, FilterIcon, DownloadIcon, EyeIcon, EditIcon, TrashIcon, CheckCircleIcon, XCircleIcon, SearchIcon, RefreshCwIcon, ShoppingBagIcon, SmartphoneIcon, CreditCardIcon, QrCodeIcon, MapPinIcon, UserIcon, PhoneIcon, MailIcon, InboxIcon, ClockIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
import Table from '../../components/ui/Table';
import StatusBadge from '../../components/ui/StatusBadge';
import Modal from '../../components/ui/Modal';
// Mock data for tills
const tillsData = [{
  id: 'TILL001',
  merchantId: 1,
  merchantName: 'Bismillah Traders',
  paymentMode: 'POS',
  userName: 'Ahmed Khan',
  userId: 'AK001',
  mobileNumber: '+92 300 1234567',
  email: 'ahmed@bismillahtraders.pk',
  location: 'Shop #5, Main Market, Islamabad',
  status: 'active',
  lastActivity: '2023-10-25T14:30:00Z',
  createdAt: '2023-05-15T10:00:00Z',
  modifiedAt: '2023-09-10T11:20:00Z',
  pendingApproval: false
}, {
  id: 'TILL002',
  merchantId: 2,
  merchantName: 'Karachi Super Mart',
  paymentMode: 'QRC',
  userName: 'Fatima Ali',
  userId: 'FA002',
  mobileNumber: '+92 321 9876543',
  email: 'fatima@karachisupermart.pk',
  location: 'Branch #2, Clifton, Karachi',
  status: 'active',
  lastActivity: '2023-10-28T09:15:00Z',
  createdAt: '2023-06-20T14:00:00Z',
  modifiedAt: null,
  pendingApproval: false
}, {
  id: 'TILL003',
  merchantId: 3,
  merchantName: 'Chase Value Center Gulshan e Iqbal',
  paymentMode: 'SoftPOS',
  userName: 'Imran Malik',
  userId: 'IM003',
  mobileNumber: '+92 333 4567890',
  email: 'imran@chasevalue.pk',
  location: 'Gulshan e Iqbal Branch, Karachi',
  status: 'inactive',
  lastActivity: '2023-09-15T16:45:00Z',
  createdAt: '2023-04-10T09:30:00Z',
  modifiedAt: '2023-09-15T16:50:00Z',
  pendingApproval: false
}, {
  id: 'TILL004',
  merchantId: 4,
  merchantName: 'Orient Online Shop',
  paymentMode: 'MobilePOS',
  userName: 'Zainab Qureshi',
  userId: 'ZQ004',
  mobileNumber: '+92 345 6789012',
  email: 'zainab@orientonline.pk',
  location: 'Head Office, DHA Phase 5, Lahore',
  status: 'active',
  lastActivity: '2023-10-26T11:20:00Z',
  createdAt: '2023-07-05T13:45:00Z',
  modifiedAt: null,
  pendingApproval: false
}, {
  id: 'TILL005',
  merchantId: 5,
  merchantName: 'Cafe Khaas',
  paymentMode: 'QRC',
  userName: 'Bilal Hassan',
  userId: 'BH005',
  mobileNumber: '+92 312 3456789',
  email: 'bilal@cafekhaas.pk',
  location: 'F-7 Branch, Islamabad',
  status: 'active',
  lastActivity: '2023-10-27T18:30:00Z',
  createdAt: '2023-03-18T10:15:00Z',
  modifiedAt: '2023-08-05T14:20:00Z',
  pendingApproval: false
}, {
  id: 'TILL006',
  merchantId: 6,
  merchantName: 'Zeen Textile',
  paymentMode: 'POS',
  userName: 'Ayesha Siddiqui',
  userId: 'AS006',
  mobileNumber: '+92 321 7654321',
  email: 'ayesha@zeentextile.pk',
  location: 'Liberty Market Branch, Lahore',
  status: 'inactive',
  lastActivity: '2023-10-10T15:10:00Z',
  createdAt: '2023-02-12T09:00:00Z',
  modifiedAt: '2023-10-10T15:15:00Z',
  pendingApproval: false
}, {
  id: 'TILL007',
  merchantId: 7,
  merchantName: 'Islamabad Metro',
  paymentMode: 'SoftPOS',
  userName: 'Usman Khan',
  userId: 'UK007',
  mobileNumber: '+92 333 9876543',
  email: 'usman@islamabadmetro.pk',
  location: 'G-9 Branch, Islamabad',
  status: 'active',
  lastActivity: '2023-10-28T12:45:00Z',
  createdAt: '2023-05-30T11:30:00Z',
  modifiedAt: null,
  pendingApproval: false
}, {
  id: 'TILL008',
  merchantId: 8,
  merchantName: 'Ginsoy Lahore',
  paymentMode: 'MobilePOS',
  userName: 'Saad Ahmed',
  userId: 'SA008',
  mobileNumber: '+92 345 1234567',
  email: 'saad@ginsoylahore.pk',
  location: 'MM Alam Road, Lahore',
  status: 'active',
  lastActivity: '2023-10-25T20:15:00Z',
  createdAt: '2023-06-15T16:00:00Z',
  modifiedAt: '2023-09-20T13:10:00Z',
  pendingApproval: false
}, {
  id: 'TILL009',
  merchantId: 1,
  merchantName: 'Bismillah Traders',
  paymentMode: 'QRC',
  userName: 'Faisal Malik',
  userId: 'FM009',
  mobileNumber: '+92 300 9876543',
  email: 'faisal@bismillahtraders.pk',
  location: 'Branch #2, Blue Area, Islamabad',
  status: 'active',
  lastActivity: '2023-10-27T09:30:00Z',
  createdAt: '2023-07-20T10:45:00Z',
  modifiedAt: null,
  pendingApproval: false
}, {
  id: 'TILL010',
  merchantId: 3,
  merchantName: 'Chase Value Center Gulshan e Iqbal',
  paymentMode: 'POS',
  userName: 'Nadia Iqbal',
  userId: 'NI010',
  mobileNumber: '+92 321 5678901',
  email: 'nadia@chasevalue.pk',
  location: 'Gulistan-e-Johar Branch, Karachi',
  status: 'pending',
  lastActivity: null,
  createdAt: '2023-10-28T09:00:00Z',
  modifiedAt: null,
  pendingApproval: true
}];
// Pending approval tills
const pendingApprovalTills = [{
  id: 'TILL010',
  merchantId: 3,
  merchantName: 'Chase Value Center Gulshan e Iqbal',
  paymentMode: 'POS',
  userName: 'Nadia Iqbal',
  userId: 'NI010',
  mobileNumber: '+92 321 5678901',
  email: 'nadia@chasevalue.pk',
  location: 'Gulistan-e-Johar Branch, Karachi',
  status: 'pending',
  lastActivity: null,
  createdAt: '2023-10-28T09:00:00Z',
  modifiedAt: null,
  pendingApproval: true,
  requestType: 'add',
  requestedBy: 'maker@example.com',
  requestedAt: '2023-10-28T09:00:00Z'
}, {
  id: 'TILL006',
  merchantId: 6,
  merchantName: 'Zeen Textile',
  paymentMode: 'QRC',
  userName: 'Ayesha Siddiqui',
  userId: 'AS006',
  mobileNumber: '+92 321 7654321',
  email: 'ayesha@zeentextile.pk',
  location: 'Liberty Market Branch, Lahore',
  status: 'pending',
  lastActivity: '2023-10-10T15:10:00Z',
  createdAt: '2023-02-12T09:00:00Z',
  modifiedAt: '2023-10-28T11:15:00Z',
  pendingApproval: true,
  requestType: 'modify',
  requestedBy: 'maker@example.com',
  requestedAt: '2023-10-28T11:15:00Z',
  changes: {
    paymentMode: {
      from: 'POS',
      to: 'QRC'
    }
  }
}];
interface Till {
  id: string;
  merchantId: number;
  merchantName: string;
  paymentMode: string;
  userName: string;
  userId: string;
  mobileNumber: string;
  email: string;
  location: string;
  status: string;
  lastActivity: string | null;
  createdAt: string;
  modifiedAt: string | null;
  pendingApproval: boolean;
  requestType?: string;
  requestedBy?: string;
  requestedAt?: string;
  changes?: Record<string, {
    from: string;
    to: string;
  }>;
}
const TillList: React.FC = () => {
  const navigate = useNavigate();
  const [tills, setTills] = useState<Till[]>(tillsData);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedTill, setSelectedTill] = useState<Till | null>(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showPendingApprovals, setShowPendingApprovals] = useState(false);
  // Filters
  const [statusFilter, setStatusFilter] = useState<string>('');
  const [paymentModeFilter, setPaymentModeFilter] = useState<string>('');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const handleAddTill = () => {
    navigate('/tills/new');
  };
  const handleEditTill = (till: Till) => {
    navigate(`/tills/edit/${till.id}`);
  };
  const handleDeleteTill = (till: Till) => {
    setSelectedTill(till);
    setShowDeleteModal(true);
  };
  const handleViewTill = (till: Till) => {
    setSelectedTill(till);
    setShowViewModal(true);
  };
  const handleViewApproval = (till: Till) => {
    setSelectedTill(till);
    setShowApprovalModal(true);
  };
  const confirmDelete = () => {
    // Delete logic would go here
    setShowDeleteModal(false);
    setSelectedTill(null);
  };
  const approveRequest = () => {
    // Approval logic would go here
    setShowApprovalModal(false);
    setSelectedTill(null);
  };
  const rejectRequest = () => {
    // Rejection logic would go here
    setShowApprovalModal(false);
    setSelectedTill(null);
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'active':
        return <StatusBadge status="success" text="Active" data-id="element-6795" />;
      case 'inactive':
        return <StatusBadge status="danger" text="Inactive" data-id="element-6796" />;
      case 'pending':
        return <StatusBadge status="warning" text="Pending" data-id="element-6797" />;
      default:
        return <StatusBadge status="default" text={status} data-id="element-6798" />;
    }
  };
  const getPaymentModeIcon = (mode: string) => {
    switch (mode) {
      case 'POS':
        return <CreditCardIcon className="h-5 w-5 text-blue-500" data-id="element-6799" />;
      case 'QRC':
        return <QrCodeIcon className="h-5 w-5 text-purple-500" data-id="element-6800" />;
      case 'SoftPOS':
        return <SmartphoneIcon className="h-5 w-5 text-green-500" data-id="element-6801" />;
      case 'MobilePOS':
        return <ShoppingBagIcon className="h-5 w-5 text-orange-500" data-id="element-6802" />;
      default:
        return null;
    }
  };
  const formatDate = (dateString: string | null) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };
  const formatDateTime = (dateTimeString: string | null) => {
    if (!dateTimeString) return 'N/A';
    const date = new Date(dateTimeString);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
  };
  // Filter tills based on search term and filters
  const filteredTills = tills.filter(till => {
    const matchesSearch = searchTerm === '' || till.merchantName.toLowerCase().includes(searchTerm.toLowerCase()) || till.id.toLowerCase().includes(searchTerm.toLowerCase()) || till.userName.toLowerCase().includes(searchTerm.toLowerCase()) || till.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === '' || till.status === statusFilter;
    const matchesPaymentMode = paymentModeFilter === '' || till.paymentMode === paymentModeFilter;
    return matchesSearch && matchesStatus && matchesPaymentMode;
  });
  // Get pending approval tills
  const pendingTills = showPendingApprovals ? pendingApprovalTills : [];
  const columns = [{
    header: 'Till ID',
    accessor: 'id',
    sortable: true
  }, {
    header: 'Merchant Name',
    accessor: 'merchantName',
    sortable: true
  }, {
    header: 'Payment Mode',
    accessor: (till: Till) => <div className="flex items-center" data-id="element-6803">
          {getPaymentModeIcon(till.paymentMode)}
          <span className="ml-2" data-id="element-6804">{till.paymentMode}</span>
        </div>,
    sortable: false
  }, {
    header: 'Till User',
    accessor: (till: Till) => <div data-id="element-6805">
          <div data-id="element-6806">{till.userName}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-6807">
            ID: {till.userId}
          </div>
        </div>,
    sortable: false
  }, {
    header: 'Contact Info',
    accessor: (till: Till) => <div data-id="element-6808">
          <div className="flex items-center text-xs text-gray-600 dark:text-gray-400" data-id="element-6809">
            <PhoneIcon className="h-3 w-3 mr-1" data-id="element-6810" />
            {till.mobileNumber}
          </div>
          <div className="flex items-center text-xs text-gray-600 dark:text-gray-400 mt-1" data-id="element-6811">
            <MailIcon className="h-3 w-3 mr-1" data-id="element-6812" />
            {till.email}
          </div>
        </div>,
    sortable: false
  }, {
    header: 'Location',
    accessor: (till: Till) => <div className="flex items-start" data-id="element-6813">
          <MapPinIcon className="h-4 w-4 mr-1 mt-0.5 text-gray-500 dark:text-gray-400 flex-shrink-0" data-id="element-6814" />
          <span className="text-sm" data-id="element-6815">{till.location}</span>
        </div>,
    sortable: false
  }, {
    header: 'Status',
    accessor: (till: Till) => <div data-id="element-6816">
          {getStatusBadge(till.status)}
          {till.pendingApproval && <div className="text-xs text-yellow-600 dark:text-yellow-400 mt-1 flex items-center" data-id="element-6817">
              <ClockIcon className="h-3 w-3 mr-1" data-id="element-6818" />
              Pending Approval
            </div>}
        </div>,
    sortable: false
  }];
  const pendingColumns = [{
    header: 'Request Type',
    accessor: (till: Till) => <StatusBadge status={till.requestType === 'add' ? 'success' : 'info'} text={till.requestType === 'add' ? 'New Till' : 'Modification'} data-id="element-6819" />,
    sortable: false
  }, {
    header: 'Till ID',
    accessor: 'id',
    sortable: true
  }, {
    header: 'Merchant Name',
    accessor: 'merchantName',
    sortable: true
  }, {
    header: 'Payment Mode',
    accessor: (till: Till) => <div className="flex items-center" data-id="element-6820">
          {getPaymentModeIcon(till.paymentMode)}
          <span className="ml-2" data-id="element-6821">{till.paymentMode}</span>
        </div>,
    sortable: false
  }, {
    header: 'Till User',
    accessor: (till: Till) => <div data-id="element-6822">
          <div data-id="element-6823">{till.userName}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-6824">
            ID: {till.userId}
          </div>
        </div>,
    sortable: false
  }, {
    header: 'Requested By',
    accessor: (till: Till) => <div data-id="element-6825">
          <div data-id="element-6826">{till.requestedBy}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-6827">
            {formatDateTime(till.requestedAt)}
          </div>
        </div>,
    sortable: false
  }];
  return <div className="space-y-6" data-id="element-6828">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-6829">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-6830">
          Till Management
        </h1>
        <div className="mt-3 sm:mt-0 flex flex-wrap gap-2" data-id="element-6831">
          <button onClick={() => setShowPendingApprovals(!showPendingApprovals)} className={`inline-flex items-center px-4 py-2 border ${showPendingApprovals ? 'border-blue-300 bg-blue-50 text-blue-700 dark:border-blue-700 dark:bg-blue-900/30 dark:text-blue-300' : 'border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800'} rounded-md shadow-sm text-sm font-medium hover:bg-gray-50 dark:hover:bg-gray-700`} data-id="element-6832">
            <InboxIcon className="h-4 w-4 mr-2" data-id="element-6833" />
            {pendingApprovalTills.length > 0 && <span className="bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center mr-2" data-id="element-6834">
                {pendingApprovalTills.length}
              </span>}
            Pending Approvals
          </button>
          <button onClick={() => setShowFilters(!showFilters)} className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-6835">
            <FilterIcon className="h-4 w-4 mr-2" data-id="element-6836" />
            Filters
          </button>
          <button className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-6837">
            <DownloadIcon className="h-4 w-4 mr-2" data-id="element-6838" />
            Export
          </button>
          <button onClick={handleAddTill} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-6839">
            <PlusIcon className="h-4 w-4 mr-2" data-id="element-6840" />
            Add Till
          </button>
        </div>
      </div>

      {showFilters && <Card data-id="element-6841">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-6842">
            <div data-id="element-6843">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-6844">
                Search
              </label>
              <div className="relative" data-id="element-6845">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-6846">
                  <SearchIcon className="h-4 w-4 text-gray-400 dark:text-gray-500" data-id="element-6847" />
                </div>
                <input type="text" className="w-full pl-10 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Search by merchant, till ID, user..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-6848" />
              </div>
            </div>
            <div data-id="element-6849">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-6850">
                Status
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-6851">
                <option value="" data-id="element-6852">All Statuses</option>
                <option value="active" data-id="element-6853">Active</option>
                <option value="inactive" data-id="element-6854">Inactive</option>
                <option value="pending" data-id="element-6855">Pending</option>
              </select>
            </div>
            <div data-id="element-6856">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-6857">
                Payment Mode
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" value={paymentModeFilter} onChange={e => setPaymentModeFilter(e.target.value)} data-id="element-6858">
                <option value="" data-id="element-6859">All Payment Modes</option>
                <option value="POS" data-id="element-6860">POS</option>
                <option value="QRC" data-id="element-6861">QRC</option>
                <option value="SoftPOS" data-id="element-6862">SoftPOS</option>
                <option value="MobilePOS" data-id="element-6863">MobilePOS</option>
              </select>
            </div>
            <div data-id="element-6864">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-6865">
                Merchant
              </label>
              <select className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-6866">
                <option value="" data-id="element-6867">All Merchants</option>
                <option value="1" data-id="element-6868">Bismillah Traders</option>
                <option value="2" data-id="element-6869">Karachi Super Mart</option>
                <option value="3" data-id="element-6870">Chase Value Center Gulshan e Iqbal</option>
                <option value="4" data-id="element-6871">Orient Online Shop</option>
                <option value="5" data-id="element-6872">Cafe Khaas</option>
                <option value="6" data-id="element-6873">Zeen Textile</option>
                <option value="7" data-id="element-6874">Islamabad Metro</option>
                <option value="8" data-id="element-6875">Ginsoy Lahore</option>
              </select>
            </div>
            <div data-id="element-6876">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-6877">
                Created From
              </label>
              <input type="date" className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-6878" />
            </div>
            <div data-id="element-6879">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-6880">
                Created To
              </label>
              <input type="date" className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" data-id="element-6881" />
            </div>
          </div>
          <div className="mt-4 flex justify-end space-x-3" data-id="element-6882">
            <button className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" onClick={() => {
          setStatusFilter('');
          setPaymentModeFilter('');
          setSearchTerm('');
        }} data-id="element-6883">
              Reset
            </button>
            <button className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-6884">
              Apply Filters
            </button>
          </div>
        </Card>}

      {showPendingApprovals ? <Card data-id="element-6885">
          <div className="mb-4 flex items-center justify-between" data-id="element-6886">
            <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-6887">
              {pendingTills.length} pending approval requests
            </div>
            <button onClick={() => setShowPendingApprovals(false)} className="text-sm text-blue-600 dark:text-blue-400 hover:underline" data-id="element-6888">
              Back to Till List
            </button>
          </div>
          <Table columns={pendingColumns} data={pendingTills} keyField="id" actions={till => <div className="flex justify-end space-x-2" data-id="element-6890">
                <button onClick={() => handleViewApproval(till)} className="p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700" title="View Details" data-id="element-6891">
                  <EyeIcon className="h-5 w-5" data-id="element-6892" />
                </button>
              </div>} data-id="element-6889" />
        </Card> : <Card data-id="element-6893">
          <div className="mb-4 flex items-center justify-between" data-id="element-6894">
            <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-6895">
              {filteredTills.length} tills found
            </div>
            <div className="flex items-center space-x-2" data-id="element-6896">
              <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-6897">
                Bulk Actions:
              </span>
              <select className="rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-1 px-2 text-sm" data-id="element-6898">
                <option value="" data-id="element-6899">Select Action</option>
                <option value="active" data-id="element-6900">Set Active</option>
                <option value="inactive" data-id="element-6901">Set Inactive</option>
              </select>
              <button className="px-3 py-1 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-6902">
                Apply
              </button>
            </div>
          </div>
          <Table columns={columns} data={filteredTills} keyField="id" actions={till => <div className="flex justify-end space-x-2" data-id="element-6904">
                <button onClick={() => handleViewTill(till)} className="p-1 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700" title="View" data-id="element-6905">
                  <EyeIcon className="h-5 w-5" data-id="element-6906" />
                </button>
                <button onClick={() => handleEditTill(till)} className="p-1 rounded-full text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/30" title="Edit" data-id="element-6907">
                  <EditIcon className="h-5 w-5" data-id="element-6908" />
                </button>
                <button onClick={() => handleDeleteTill(till)} className="p-1 rounded-full text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30" title="Delete" data-id="element-6909">
                  <TrashIcon className="h-5 w-5" data-id="element-6910" />
                </button>
              </div>} data-id="element-6903" />
        </Card>}

      {/* View Till Modal */}
      <Modal isOpen={showViewModal} onClose={() => setShowViewModal(false)} title="Till Details" size="lg" data-id="element-6911">
        {selectedTill && <div className="space-y-4" data-id="element-6912">
            <div className="flex items-center" data-id="element-6913">
              <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-700 mr-3" data-id="element-6914">
                {getPaymentModeIcon(selectedTill.paymentMode)}
              </div>
              <div data-id="element-6915">
                <h3 className="text-lg font-medium" data-id="element-6916">{selectedTill.id}</h3>
                <div className="flex items-center mt-1" data-id="element-6917">
                  {getStatusBadge(selectedTill.status)}
                  <span className="mx-2 text-gray-500 dark:text-gray-400" data-id="element-6918">
                    •
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-6919">
                    {selectedTill.paymentMode}
                  </span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" data-id="element-6920">
              <div data-id="element-6921">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-6922">
                  Merchant Information
                </h4>
                <div className="mt-2 space-y-2" data-id="element-6923">
                  <p data-id="element-6924">
                    <span className="font-medium" data-id="element-6925">Merchant Name:</span>{' '}
                    {selectedTill.merchantName}
                  </p>
                  <p data-id="element-6926">
                    <span className="font-medium" data-id="element-6927">Merchant ID:</span>{' '}
                    {selectedTill.merchantId}
                  </p>
                </div>
              </div>
              <div data-id="element-6928">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-6929">
                  Till Details
                </h4>
                <div className="mt-2 space-y-2" data-id="element-6930">
                  <p data-id="element-6931">
                    <span className="font-medium" data-id="element-6932">Payment Mode:</span>{' '}
                    {selectedTill.paymentMode}
                  </p>
                  <p data-id="element-6933">
                    <span className="font-medium" data-id="element-6934">Created On:</span>{' '}
                    {formatDate(selectedTill.createdAt)}
                  </p>
                  {selectedTill.modifiedAt && <p data-id="element-6935">
                      <span className="font-medium" data-id="element-6936">Last Modified:</span>{' '}
                      {formatDate(selectedTill.modifiedAt)}
                    </p>}
                  <p data-id="element-6937">
                    <span className="font-medium" data-id="element-6938">Last Activity:</span>{' '}
                    {formatDateTime(selectedTill.lastActivity)}
                  </p>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-6939">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-6940">
                Till User Information
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6941">
                <div className="space-y-2" data-id="element-6942">
                  <p data-id="element-6943">
                    <span className="font-medium" data-id="element-6944">User Name:</span>{' '}
                    {selectedTill.userName}
                  </p>
                  <p data-id="element-6945">
                    <span className="font-medium" data-id="element-6946">User ID:</span>{' '}
                    {selectedTill.userId}
                  </p>
                </div>
                <div className="space-y-2" data-id="element-6947">
                  <p data-id="element-6948">
                    <span className="font-medium" data-id="element-6949">Mobile Number:</span>{' '}
                    {selectedTill.mobileNumber}
                  </p>
                  <p data-id="element-6950">
                    <span className="font-medium" data-id="element-6951">Email:</span>{' '}
                    {selectedTill.email}
                  </p>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-6952">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-6953">
                Location Information
              </h4>
              <div className="flex items-start" data-id="element-6954">
                <MapPinIcon className="h-5 w-5 mr-2 mt-0.5 text-gray-500 dark:text-gray-400 flex-shrink-0" data-id="element-6955" />
                <p data-id="element-6956">{selectedTill.location}</p>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-6957">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-6958">
                Quick Actions
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-6959">
                <button onClick={() => {
              setShowViewModal(false);
              handleEditTill(selectedTill);
            }} className="px-3 py-1 bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300 rounded-md text-sm flex items-center" data-id="element-6960">
                  <EditIcon className="h-4 w-4 mr-1" data-id="element-6961" />
                  Edit Till
                </button>
                {selectedTill.status === 'active' ? <button className="px-3 py-1 bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300 rounded-md text-sm flex items-center" data-id="element-6962">
                    <XCircleIcon className="h-4 w-4 mr-1" data-id="element-6963" />
                    Deactivate
                  </button> : <button className="px-3 py-1 bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300 rounded-md text-sm flex items-center" data-id="element-6964">
                    <CheckCircleIcon className="h-4 w-4 mr-1" data-id="element-6965" />
                    Activate
                  </button>}
                <button className="px-3 py-1 bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300 rounded-md text-sm flex items-center" data-id="element-6966">
                  <RefreshCwIcon className="h-4 w-4 mr-1" data-id="element-6967" />
                  Reset Credentials
                </button>
              </div>
            </div>
          </div>}
      </Modal>

      {/* Approval Modal */}
      <Modal isOpen={showApprovalModal} onClose={() => setShowApprovalModal(false)} title="Approval Request Details" size="lg" data-id="element-6968">
        {selectedTill && <div className="space-y-4" data-id="element-6969">
            <div className="flex items-center" data-id="element-6970">
              <div className="p-2 rounded-full bg-gray-100 dark:bg-gray-700 mr-3" data-id="element-6971">
                {getPaymentModeIcon(selectedTill.paymentMode)}
              </div>
              <div data-id="element-6972">
                <h3 className="text-lg font-medium" data-id="element-6973">{selectedTill.id}</h3>
                <div className="flex items-center mt-1" data-id="element-6974">
                  <StatusBadge status={selectedTill.requestType === 'add' ? 'success' : 'info'} text={selectedTill.requestType === 'add' ? 'New Till' : 'Modification'} data-id="element-6975" />
                  <span className="mx-2 text-gray-500 dark:text-gray-400" data-id="element-6976">
                    •
                  </span>
                  <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-6977">
                    Requested by {selectedTill.requestedBy} on{' '}
                    {formatDateTime(selectedTill.requestedAt)}
                  </span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" data-id="element-6978">
              <div data-id="element-6979">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-6980">
                  Merchant Information
                </h4>
                <div className="mt-2 space-y-2" data-id="element-6981">
                  <p data-id="element-6982">
                    <span className="font-medium" data-id="element-6983">Merchant Name:</span>{' '}
                    {selectedTill.merchantName}
                  </p>
                  <p data-id="element-6984">
                    <span className="font-medium" data-id="element-6985">Merchant ID:</span>{' '}
                    {selectedTill.merchantId}
                  </p>
                </div>
              </div>
              <div data-id="element-6986">
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-6987">
                  Till Details
                </h4>
                <div className="mt-2 space-y-2" data-id="element-6988">
                  <p data-id="element-6989">
                    <span className="font-medium" data-id="element-6990">Payment Mode:</span>{' '}
                    {selectedTill.paymentMode}
                    {selectedTill.changes?.paymentMode && <span className="ml-2 text-xs bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300 px-2 py-0.5 rounded" data-id="element-6991">
                        Changed from {selectedTill.changes.paymentMode.from}
                      </span>}
                  </p>
                  {selectedTill.requestType === 'add' ? <p data-id="element-6992">
                      <span className="font-medium" data-id="element-6993">Created On:</span>{' '}
                      {formatDate(selectedTill.createdAt)}
                    </p> : <p data-id="element-6994">
                      <span className="font-medium" data-id="element-6995">Modified On:</span>{' '}
                      {formatDate(selectedTill.modifiedAt || '')}
                    </p>}
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-6996">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-6997">
                Till User Information
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6998">
                <div className="space-y-2" data-id="element-6999">
                  <p data-id="element-7000">
                    <span className="font-medium" data-id="element-7001">User Name:</span>{' '}
                    {selectedTill.userName}
                  </p>
                  <p data-id="element-7002">
                    <span className="font-medium" data-id="element-7003">User ID:</span>{' '}
                    {selectedTill.userId}
                  </p>
                </div>
                <div className="space-y-2" data-id="element-7004">
                  <p data-id="element-7005">
                    <span className="font-medium" data-id="element-7006">Mobile Number:</span>{' '}
                    {selectedTill.mobileNumber}
                  </p>
                  <p data-id="element-7007">
                    <span className="font-medium" data-id="element-7008">Email:</span>{' '}
                    {selectedTill.email}
                  </p>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-7009">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-7010">
                Location Information
              </h4>
              <div className="flex items-start" data-id="element-7011">
                <MapPinIcon className="h-5 w-5 mr-2 mt-0.5 text-gray-500 dark:text-gray-400 flex-shrink-0" data-id="element-7012" />
                <p data-id="element-7013">{selectedTill.location}</p>
              </div>
            </div>
            <div className="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4" data-id="element-7014">
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2" data-id="element-7015">
                Approval Decision
              </h4>
              <div className="space-y-3" data-id="element-7016">
                <div data-id="element-7017">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-7018">
                    Comments (Optional)
                  </label>
                  <textarea rows={3} className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-2 px-3 text-sm" placeholder="Add comments about your decision..." data-id="element-7019" />
                </div>
                <div className="flex space-x-3 justify-end" data-id="element-7020">
                  <button onClick={rejectRequest} className="px-4 py-2 border border-red-300 dark:border-red-700 text-red-700 dark:text-red-400 bg-red-50 dark:bg-red-900/10 rounded-md text-sm font-medium hover:bg-red-100 dark:hover:bg-red-900/30" data-id="element-7021">
                    Reject
                  </button>
                  <button onClick={approveRequest} className="px-4 py-2 border border-transparent bg-green-600 hover:bg-green-700 text-white rounded-md text-sm font-medium" data-id="element-7022">
                    Approve
                  </button>
                </div>
              </div>
            </div>
          </div>}
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteModal} onClose={() => setShowDeleteModal(false)} title="Confirm Deletion" footer={<>
            <button onClick={() => setShowDeleteModal(false)} className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-7024">
              Cancel
            </button>
            <button onClick={confirmDelete} className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-7025">
              Delete
            </button>
          </>} data-id="element-7023">
        <p className="text-gray-700 dark:text-gray-300" data-id="element-7026">
          Are you sure you want to delete the till "{selectedTill?.id}" for
          merchant "{selectedTill?.merchantName}"? This action cannot be undone.
        </p>
      </Modal>
    </div>;
};
export default TillList;